import { render, staticRenderFns } from "./ProductSpecsElementIndex.vue?vue&type=template&id=1e499d2b"
import script from "./ProductSpecsElementIndex.vue?vue&type=script&lang=js"
export * from "./ProductSpecsElementIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e499d2b')) {
      api.createRecord('1e499d2b', component.options)
    } else {
      api.reload('1e499d2b', component.options)
    }
    module.hot.accept("./ProductSpecsElementIndex.vue?vue&type=template&id=1e499d2b", function () {
      api.rerender('1e499d2b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/productSpecsElement/ProductSpecsElementIndex.vue"
export default component.exports